import { createFileRoute, redirect } from "@tanstack/react-router";
import { FromMessage } from "@/features/orders/FromMessage";
import { hasModule, firstAllowedRoute } from "@/lib/auth";

// /orders/new/from-message — a screen of its own, not drawn inside the four steps: it is
// two full-height columns, and "Terug" simply lands in the entry screen (handoff §5.1).
// The trailing underscore on `new_` is what keeps it out of that layout.
export const Route = createFileRoute("/_shell/orders/new_/from-message")({
  // The same right as typing an order by hand: it makes the same order.
  beforeLoad: ({ context }) => {
    if (context.session.roles.includes("admin") || hasModule(context.session, "tms_orders_write")) return;
    if (hasModule(context.session, "tms_orders")) throw redirect({ to: "/orders" });
    throw redirect({ to: firstAllowedRoute(context.session) });
  },
  component: FromMessage,
});
